import { getCurrentPath } from "@faire/web--source/common/Path";

export const isMobileApp = () =>
  getCurrentPath().searchParams.get("native_env") === "true";
